import cn from 'classnames';
import React, { useEffect, useReducer, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// TYPES
import { STATE_DEFAULTS, TGamePlayInformation } from './GamePlayInformation.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { getGamePlayMessages, getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

import { DOM_ID } from '@UILayer/UILayer.types';

const GamePlayInformation: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: TGamePlayInformation, newState: any) => ({ ...state, ...newState }), STATE_DEFAULTS);

    const gameStoreGamePlayMessages = useAppSelector(getGamePlayMessages);
    const { t } = useTranslation();
    const textRef = useRef<HTMLDivElement>(null);
    const textContainerRef = useRef<HTMLDivElement>(null);
    const globalStyles = useAppSelector(getGlobalStyles);
    const informationCN = cn(styles.information_container, globalStyles.orientation);

    useEffect(() => {
        const { information, showInformation } = gameStoreGamePlayMessages;

        setState({
            information: information,
            showInformation: showInformation,
            marqueText: false
        });
    }, [gameStoreGamePlayMessages]);

    useEffect(() => {
        calculateTextLenght();
    }, [state.information]);

    function calculateTextLenght() {
        if (textRef && textContainerRef) {
            const textWidth = textRef.current?.getBoundingClientRect().width;
            const containerWidth = textContainerRef.current?.getBoundingClientRect().width;
            if (textWidth && containerWidth && textWidth > containerWidth) {
                setState({ marqueText: true });
            } else {
                setState({ marqueText: false });
            }
        }
    }

    return (
        <>
            {state.showInformation && (
                <>
                    <div
                        ref={textContainerRef}
                        className={informationCN}
                        tabIndex={0}
                        aria-description={t('WCA_ADDITIONAL_WIN_INFORMATION')}
                        aria-valuetext={state.information}
                    >
                        {state.marqueText ? (
                            <>
                                <div className={styles.marque_container}>
                                    <div ref={textRef} className={styles.marque_text} id={DOM_ID.ADDITIONAL_INFORMATION}>
                                        {state.information}
                                    </div>
                                    <div ref={textRef} className={styles.marque_text} aria-hidden={true}>
                                        {state.information}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <span ref={textRef} id={DOM_ID.ADDITIONAL_INFORMATION}>
                                    {state.information}
                                </span>
                            </>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default GamePlayInformation;
